import md5 from 'md5';
import moment from 'moment';
import { Request } from './requests';
import store from '../store/store';
import Vue from "vue"


export class Cache {

    constructor() {
        this.issue_dropdown_endpoints = []
        this.endpoints = []
        this.error_endpoints = []
        this.category_endpoints = []
        this.issue_type = [
            'highway',
            'occupational',
            'hazard',
            'road_user_accident',
            'enroachment_row',
            'vehicle_breakdown',
            'unauthorised_parking',
            'traffic_violation',
            'dead_animal_debris_removal',
            'material_damage',
            'unauthorised_access',
            'unauthorised_media_cut',
            'other',
            'routine_maintenance',
            'major_maintenance',
            'electrical_maintenance'
        ]
    }

    run_cache() {
        return new Promise(async (resolve, reject) => {

            //running issue dropdown enpoints
            this.cache_issue_dropdown_endpoints()
            await this.run_cache_issue_dropdown_endpoints()

            // running independent endpoints 
            this.cache_independent_endpoints()
            await this.run_cache_independent_endpoints()
    
            // running category endpoints
            this.cache_category_endpoints()
            await this.run_cache_category_endpoints()
            
            if (this.error_endpoints.length)
                return reject()
            
            return resolve()
        })
    }

    issue_dropdown_permission(issue_type) {
        let permission = []
        permission.push(`review__all__issue_${issue_type}`)
        permission.push(`review__assigned__issue_${issue_type}`)

        return permission.toString()
    }

    cache_issue_dropdown_endpoints() {
        for(let i=0; i<this.issue_type.length; i++) {
            let permission = this.issue_dropdown_permission(this.issue_type[i])
            let endpoint = `${store.state.apiendpoints.organisation_users}?permission=${permission}&is_active=true`
            this.issue_dropdown_endpoints.push(endpoint)
        }
    }

    async run_cache_issue_dropdown_endpoints() {
        
        for(let i=0; i<this.issue_dropdown_endpoints.length; i++) {
            await this.do_cache_endpoints(this.issue_dropdown_endpoints[i])
        }
    
    }

    cache_independent_endpoints() {

        this.endpoints = [
            // authority type 
            `${store.state.apiendpoints.data_authority_types}?active=true`,
            // reported by 
            `${store.state.apiendpoints.organisation_users}?is_active=true`,
            // nature of accident 
            `${store.state.apiendpoints.data_nature_of_accidents}?active=true`,
            //road features
            `${store.state.apiendpoints.data_road_features}?active=true`,
            // road condition 
            `${store.state.apiendpoints.data_road_conditions}?active=true`,
            // intersection type
            `${store.state.apiendpoints.data_intersection_types}?active=true`,
            // weather Condition 
            `${store.state.apiendpoints.data_weather_conditions}?active=true`,
            // accident type in roaduseraccident issue
            `${store.state.apiendpoints.data_accident_type}?active=true`,
            // help provided by 
            `${store.state.apiendpoints.data_help_types}?active=true`,
            // type of enroachment
            `${store.state.apiendpoints.data_enroachment_types}?active=true`,
            // vehicle type in unauthorised parking issue
            `${store.state.apiendpoints.data_vehicle_types}?issue_type_category=unauthorised_parking&active=true`,
            // vehicle type in traffic violation issue
            `${store.state.apiendpoints.data_vehicle_types}?issue_type_category=traffic_violation&active=true`,
            // vehicle type in vehicle breakdown issue
            `${store.state.apiendpoints.data_vehicle_types}?issue_type_category=vehicle_breakdown&active=true`,
            // accident classification in occupational issue 
            `${store.state.apiendpoints.data_accident_classifications}?accident_type_category=occupational&active=true`,
            // accident classification in roaduseraccident issue 
            `${store.state.apiendpoints.data_accident_classifications}?accident_type_category=road_user_accident&active=true`,
            // causes in roaduseraccident issue 
            `${store.state.apiendpoints.data_causes}?issue_type_category=road_user_accident&active=true`,
            // vehicle type in roaduseraccident issue
            `${store.state.apiendpoints.data_vehicle_types}?issue_type_category=road_user_accident&active=true`,
            // type of road
            `${store.state.apiendpoints.data_type_of_roads}?active=true`
        ]
    }

    async run_cache_independent_endpoints() {
        
        for(let i=0; i<this.endpoints.length; i++) {
            await this.do_cache_endpoints(this.endpoints[i])
        }
    
    }

    cache_category_endpoints() {
        this.category_endpoints = [
            // for routine maintenance 
            `${store.state.apiendpoints.data_categories}?issue_type_category=routine_maintenance&active=true`,
            // for electrical maintenance 
            `${store.state.apiendpoints.data_categories}?issue_type_category=electrical_maintenance&active=true`,
            // for major maintenance 
            `${store.state.apiendpoints.data_categories}?issue_type_category=major_maintenance&active=true`,
            // for corrective maintenance 
            `${store.state.apiendpoints.data_categories}?issue_type_category=highway&active=true`,
            // for Hazard
            `${store.state.apiendpoints.data_categories}?issue_type_category=hazard&active=true`
        ]

    }

    async run_cache_category_endpoints() {
        for(let i=0; i<this.category_endpoints.length; i++) {
            await this.do_cache_endpoints(this.category_endpoints[i], true)
        }
    }

    async run_cache_issue_type(category_results) {
        for(let i=0; i<category_results.length; i++) {

            let url = `${store.state.apiendpoints.data_issues_types}?category=${category_results[i].id}&active=true`
            await this.do_cache_endpoints(url)
        }
    }
    
    async do_cache_endpoints(url, is_category=false) {

        // if user is not online do nothing
        if(!store.state.is_online) {
            return
        }

        let key = md5(url)

        let local_data = await Vue.prototype.$ionicStorage.get(key)

        if(local_data) {
            try {
                local_data = JSON.parse(local_data)

                //checking cache is valid or not
                let cache_on = local_data.cache_timestamp
                if (cache_on < moment(new Date()).subtract(6, 'hours').toISOString()) {
                    //cache is invalid
                    await Vue.prototype.$ionicStorage.remove(key)

                } else {
                    return
                }

            } catch(err) {
                await Vue.prototype.$ionicStorage.remove(key)
            }
        }

        try {
            let res = await Request(this, 'GET', url, {limit: 1000})

            // setting cache
            await Vue.prototype.$ionicStorage.set(key, JSON.stringify({cache_timestamp: moment(new Date()).toISOString(), data: res.results}))

            if(is_category && res.results){
                await this.run_cache_issue_type(res.results)
            }
        } catch {
            this.error_endpoints.push(url)
        }
    }
}